import { Component } from '@angular/core';
import { LoadingSpinnerService } from '../results/services/loading-spinner.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-loading',
  standalone: false,
  templateUrl: './loading.component.html',
})
export class LoadingComponent {
  isLoading = false;

  constructor(private spinnerService: LoadingSpinnerService) {
    this.spinnerService.loading$
      .pipe(untilDestroyed(this))
      .subscribe((loading) => {
        this.isLoading = loading;
      });
  }
}
